import React from 'react';
import { Navigate } from 'react-router-dom';
// Keep old bookmarks working without retaining a subscription sales page.
export default function PricingPage() { return <Navigate to="/roles" replace />; }
